import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import CompanyProfile from '@/components/CompanyProfile'
import CompanyProducts from '@/components/CompanyProducts'
import CooperativePartner from '@/components/CooperativePartner'
import ContactUs from '@/components/ContactUs'
import Dynamic from '@/components/IndustryDynamics'
import Detailstest from '@/components/DynamicDetails'

// 产品组件
import Palm from '@/components/Products/Palm.vue'
import WiseDoctor from '@/components/Products/WiseDoctor.vue'
import KnowGrass from '@/components/Products/KnowGrass.vue'
import TerminalMachine from '@/components/Products/TerminalMachine.vue'
// 导航组件
import HeadTail from '@/components/publicComponent/HeadTail.vue'
// 尾部组件
import Navigation from '@/components/publicComponent/Navigation.vue'
// 回滚顶部底部组件
import ReturnTop from '@/components/publicComponent/ReturnTop.vue'
//产品使用手册
import ProductManual from '@/components/Products/ProductManual.vue'



Vue.use(VueRouter)
export default new VueRouter({
  mode: "history",
  routes: [
    { path: '/404', component: () => import('@/components/404') },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/CompanyProfile',
      name: 'CompanyProfile',
      component: CompanyProfile
    },
    {
      path: '/CompanyProducts',
      name: 'CompanyProducts',
      component: CompanyProducts
    },
    {
      path: '/CooperativePartner',
      name: 'CooperativePartner',
      component: CooperativePartner
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/Dynamic',
      name: 'Dynamic',
      component: Dynamic,
    },
    {
      path: '/Detailstest',
      name: 'Detailstest',
      component: Detailstest
    },
    {
      path: '/Palm',
      name: 'Palm',
      component: Palm
    },
    {
      path: '/WiseDoctor',
      name: 'WiseDoctor',
      component: WiseDoctor
    },
    {
      path: '/KnowGrass',
      name: 'KnowGrass',
      component: KnowGrass
    },
    {
      path: '/TerminalMachine',
      name: 'TerminalMachine',
      component: TerminalMachine
    },
    {
      path: '/HeadTail',
      name: 'HeadTail',
      component: HeadTail
    },
    {
      path: '/Navigation',
      name: 'Navigation',
      component: Navigation
    },
    {
      path: '/ReturnTop',
      name: 'ReturnTop',
      component: ReturnTop
    },
    {
      path: '/ProductManual',
      name: 'ProductManual',
      component: ProductManual
    },
    { path: '*', redirect: '/404' }
  ],

})


// WEBPACK FOOTER //
// ./src/router/index.js